import { useCallback } from "react";

import { Box } from "@braintrust/braintrust-ui-components";
import { SAVED_FILTERS_ENDPOINT } from "@js/apps/common/components/save-filters/const";
import { clearSavedFilterNameIfApplied } from "@js/apps/common/components/save-filters/slice";
import { useDeleteTalentFilterMutation } from "@js/apps/freelancer/api";
import { useDeleteJobFilterMutation } from "@js/apps/jobs/api";
import { ModalConfirm, ModalInstance } from "@js/components/modal";
import { Snackbar } from "@js/components/snackbar";
import { useAppDispatch } from "@js/hooks";
import type { SavedJobFilter } from "@js/types/jobs";

import type { SavedFiltersEndpoint } from "../../const";

export const useDeleteSavedFilter = (endpoint: SavedFiltersEndpoint) => {
  const dispatch = useAppDispatch();
  const [deleteJobFilter] = useDeleteJobFilterMutation();
  const [deleteTalentFilter] = useDeleteTalentFilterMutation();

  const deleteSavedFilter = useCallback(
    (filter: Pick<SavedJobFilter, "id" | "name">) => {
      ModalInstance.open({
        children: (
          <ModalConfirm
            onCancel={ModalInstance.close}
            onConfirm={() => {
              const deleteFilter =
                endpoint === SAVED_FILTERS_ENDPOINT.JOBS
                  ? deleteJobFilter
                  : deleteTalentFilter;

              void deleteFilter(filter)
                .unwrap()
                .then(() => {
                  dispatch(clearSavedFilterNameIfApplied(filter.name));
                  Snackbar.success("Deleted saved filter.");
                  ModalInstance.close();
                });
            }}
          >
            <Box sx={{ p: "32px 16px 16px 0" }}>
              Are you sure you want to delete it?
            </Box>
          </ModalConfirm>
        ),
      });
    },
    [deleteJobFilter, deleteTalentFilter, dispatch, endpoint],
  );

  return { deleteSavedFilter };
};
